import { Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgIf } from '@angular/common';

@Component({
  selector: 'lib-formly-wrapper-transloco',
  standalone: true,
  imports: [ReactiveFormsModule, FormlyModule, TranslocoPipe, NgIf],
  template: `
    <div class="flex flex-col gap-2 relative">
      <label [for]="id" class="font-semibold block">
        {{ to.label | transloco }}
        <span
          *ngIf="to.required && to['hideRequiredMarker'] !== true"
          class="text-red-500"
          >*</span
        >
      </label>

      <ng-container #fieldComponent></ng-container>

      <div *ngIf="showError" class="text-red-500 text-sm">
        <formly-validation-message [field]="field"></formly-validation-message>
      </div>
    </div>
  `,
})
export class TranslocoFormFieldWrapper extends FieldWrapper {}
